import type { DialoguePool } from '@/state/types';

export const L16_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Sign the form. My magnetic tapes are getting impatient.',
    'Form 14-B does not sign itself. More\u2019s the pity.',
    'The punch cards are clacking about you. Unfavourably. Column M.',
  ],
  tokenLoss: [
    'Wrong pen. I told you. I\u2019m telling you again.',
    'The field rejects ink. The field rejects you. It\u2019s thematic.',
    'Bureaucracy has feelings. They\u2019re all disappointment.',
  ],
  solution: [
    'You actually signed it. You gave up a token just to see the next screen. How pathetic.',
    'You actually signed it. You gave up a token just to see the next screen. How pathetic.',
    'You actually signed it. You gave up a token just to see the next screen. How pathetic.',
  ],
  spite: ['Form 14-B. We meet again. Your signature has not improved.'],
};
